export enum ProductEntityType {
  Family = 'Family',
  Group = 'Group',
}

export enum ProductFilterModuleMode {
  BluetoothPairingGuide = 'bluetoothpairingguide',
  ContactSupport = 'contactsupport',
  Normal = 'normal',
  Support = 'support',
  Compare = 'compare',
}

export const enum ProductIncludeType {
  Available = 'available',
  Discontinued = 'discontinued',
  Supported = 'supported',
}
